declare var angular: any;
import * as _ from 'underscore';

angular
  .module('BlogControllers')
  .controller('BlogListCtrl', [
    '$scope',
    'navbar',
    'blog',
    function($scope, navbar, blog) {
      if ($scope.main.me) {
        navbar.goBackAction('Accueil', '#!/', 'navbar.home');
      }

      blog.getArticles().then(function(articles) {
        $scope.articles = articles;
      });
    }
  ])
  .controller('BlogDetailCtrl', [
    '$scope',
    'navbar',
    'blog',
    '$mdToast',
    '$location',
    '$routeParams',
    function($scope, navbar, blog, $mdToast, $location, $routeParams) {
      if ($scope.main.me) {
        navbar.goBackAction('Accueil', '#!/', 'navbar.home');
      }

      blog.getArticleByUrl($routeParams.title).then(
        function(article) {
          $scope.article = article;
          getReadNext(article);
        },
        function() {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("L'article demandé n'existe pas")
              .position('bottom right')
          );
          $location.url('/blog');
        }
      );

      function getReadNext(article) {
        blog.getArticles().then(function(articles) {
          $scope.readNext = _.without(articles, article);
        });
      }
    }
  ]);
